// extracted by mini-css-extract-plugin
module.exports = {"image":"Me_image__ed3m1","h1":"Me_h1__8WlPI","h2":"Me_h2__xLt-v","paragraph":"Me_paragraph__1P_d6","resume":"Me_resume__ADux3"};